// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-container {
  z-index: 1001;
  border-bottom: 1px solid var(--grey);
}
.header-container .hd-content-wrapper img {
  width: 24px;
  height: 24px;
  display: none;
}
.header-container nav {
  padding: 8px;
}
@media screen and (min-width: 992px) {
  .header-container nav {
    padding: 10px 40px;
  }
}
.header-container .dropdown-toggle::after {
  display: none;
}
.header-container .header-logo img {
  background-size: contain;
  background-repeat: no-repeat;
}
.header-container .navbar-toggler {
  display: none;
}
.header-container a:has(:not(.btn-primary)) {
  text-decoration: none !important;
  color: #000 !important;
  position: relative;
  font-family: "Josefin Sans", sans-serif;
}

.mobile-drawer {
  background-color: white;
  transform: translateX(100%);
  transition: all 0.3s ease-in-out;
  z-index: 1001;
  height: calc(100% - 71px);
}
.mobile-drawer.show {
  transform: translateX(0);
}
.mobile-drawer li {
  padding: 10px 0 !important;
}
.mobile-drawer span {
  font-size: 24px;
}

@media (min-width: 992px) {
  .header-container .header-li:hover span {
    color: var(--bs-orange);
  }
  .header-container .header-li:hover::after {
    width: calc(100% - 2.5rem);
  }
  .header-container .header-li::after {
    content: "";
    width: 0;
    left: 50%;
    transform: translate(-50%);
    position: absolute;
    border-bottom: 2px solid var(--bs-orange);
    top: calc(100% + 5px);
    z-index: 1001;
    transition: all 0.3s;
  }
}
@media (max-width: 992px) {
  .header-desktop-navbar {
    display: none !important;
  }
  .header-mobile-navbar {
    display: flex !important;
  }
  .header-container .header-right-container {
    position: fixed;
    top: 0%;
    z-index: 100;
    background: white;
    right: -15px;
    width: 300px;
    height: 100%;
    transform: translateX(100%);
    transition: 0.3s;
    z-index: 101;
  }
  .header-container .header-right-container.show .mobile-view-close-btn-wrapper {
    padding: 0 15px;
    border-bottom: 1px solid rgba(220, 220, 220, 0.5);
    display: flex !important;
    justify-content: right;
  }
  .header-container .header-right-container .hd-content-wrapper {
    display: flex;
    align-items: center;
  }
  .header-container .header-right-container .hd-content-wrapper span {
    margin-left: 20px;
  }
  .header-container .header-right-container.show {
    transform: translateX(0);
  }
  .header-container .pay-btn {
    display: flex;
    justify-content: center;
    padding: 8px 12px !important;
    font-size: 18px;
    width: 50%;
  }
  .header-container .login-btn {
    font-size: 18px;
    padding: 8px 12px !important;
    width: 50%;
  }
  .header-container .navbar-toggler {
    display: block !important;
    height: 45px;
    margin: 5px 0;
    border: none !important;
  }
}
@media only screen and (max-width: 576px) {
  .header-container .header-left-container .select-city-btn .select-city-dropdown-btn {
    margin-left: 20px;
    max-width: 200px;
  }
  .header-container .header-left-container .select-city-btn .address-dropdown {
    width: 90vw;
    left: 0;
    right: 0;
    margin: 0 auto;
    position: fixed;
    top: 55px;
    transform: scale(1);
  }
}
@media only screen and (max-width: 420px) {
  .header-container .header-left-container .select-city-btn .select-city-dropdown-btn {
    max-width: 100px;
  }
  .header-container .header-left-container .select-city-btn .address-dropdown {
    width: 100vw;
    height: 100%;
    left: 0;
    right: 0;
    overflow-y: auto;
    position: fixed;
    top: 0;
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/style.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,oCAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,aAAA;AACJ;AAEE;EACE,YAAA;AAAJ;AAEI;EAHF;IAII,kBAAA;EACJ;AACF;AAEE;EACE,aAAA;AAAJ;AAII;EACE,wBAAA;EACA,4BAAA;AAFN;AAME;EACE,aAAA;AAJJ;AAOE;EACE,gCAAA;EACA,sBAAA;EACA,kBAAA;EACA,uCAAA;AALJ;;AASA;EACE,uBAAA;EACA,2BAAA;EACA,gCAAA;EACA,aAAA;EACA,yBAAA;AANF;AAQE;EACE,wBAAA;AANJ;AASE;EACE,0BAAA;AAPJ;AAUE;EACE,eAAA;AARJ;;AAYA;EAIQ;IACE,uBAAA;EAZR;EAcM;IACE,0BAAA;EAZR;EAgBI;IACE,WAAA;IACA,QAAA;IACA,SAAA;IACA,0BAAA;IACA,kBAAA;IACA,yCAAA;IACA,qBAAA;IACA,aAAA;IACA,oBAAA;EAdN;AACF;AAmBA;EACE;IACE,wBAAA;EAjBF;EAoBA;IACE,wBAAA;EAlBF;EAqBE;IACE,eAAA;IACA,OAAA;IACA,YAAA;IACA,iBAAA;IACA,YAAA;IACA,YAAA;IACA,YAAA;IACA,2BAAA;IACA,gBAAA;IACA,YAAA;EAnBJ;EAsBM;IACE,eAAA;IACA,iDAAA;IACA,wBAAA;IACA,sBAAA;EApBR;EAwBI;IACE,aAAA;IACA,mBAAA;EAtBN;EAwBM;IACE,iBAAA;EAtBR;EA0BI;IACE,wBAAA;EAxBN;EA4BE;IACE,aAAA;IACA,uBAAA;IACA,4BAAA;IACA,eAAA;IACA,UAAA;EA1BJ;EA6BE;IACE,eAAA;IACA,4BAAA;IACA,UAAA;EA3BJ;EA8BE;IACE,yBAAA;IACA,YAAA;IACA,aAAA;IACA,uBAAA;EA5BJ;AACF;AAgCA;EAIQ;IACE,iBAAA;IACA,gBAAA;EAjCR;EAmCM;IACE,WAAA;IACA,OAAA;IACA,QAAA;IACA,cAAA;IACA,eAAA;IACA,SAAA;IACA,mBAAA;EAjCR;AACF;AAuCA;EAIQ;IACE,gBAAA;EAxCR;EA2CM;IACE,YAAA;IACA,YAAA;IACA,OAAA;IACA,QAAA;IAEA,gBAAA;IACA,eAAA;IACA,MAAA;IACA,mBAAA;EA1CR;AACF","sourcesContent":[".header-container {\n  z-index: 1001;\n  border-bottom: 1px solid var(--grey);\n\n  .hd-content-wrapper img {\n    width: 24px;\n    height: 24px;\n    display: none;\n  }\n\n  nav {\n    padding: 8px;\n\n    @media screen and (min-width: 992px) {\n      padding: 10px 40px;\n    }\n  }\n\n  .dropdown-toggle::after {\n    display: none;\n  }\n\n  .header-logo {\n    img {\n      background-size: contain;\n      background-repeat: no-repeat;\n    }\n  }\n\n  .navbar-toggler {\n    display: none;\n  }\n\n  a:has(:not(.btn-primary)) {\n    text-decoration: none !important;\n    color: #000 !important;\n    position: relative;\n    font-family: \"Josefin Sans\", sans-serif;\n  }\n}\n\n.mobile-drawer {\n  background-color: white;\n  transform: translateX(100%);\n  transition: all 0.3s ease-in-out;\n  z-index: 1001;\n  height: calc(100% - 71px);\n\n  &.show {\n    transform: translateX(0);\n  }\n\n  li {\n    padding: 10px 0 !important;\n  }\n\n  span {\n    font-size: 24px;\n  }\n}\n\n@media (min-width: 992px) {\n  .header-container {\n    .header-li {\n      &:hover {\n        span {\n          color: var(--bs-orange);\n        }\n        &::after {\n          width: calc(100% - 2.5rem);\n        }\n      }\n\n      &::after {\n        content: \"\";\n        width: 0;\n        left: 50%;\n        transform: translate(-50%);\n        position: absolute;\n        border-bottom: 2px solid var(--bs-orange);\n        top: calc(100% + 5px);\n        z-index: 1001;\n        transition: all 0.3s;\n      }\n    }\n  }\n}\n\n@media (max-width: 992px) {\n  .header-desktop-navbar {\n    display: none !important;\n  }\n\n  .header-mobile-navbar {\n    display: flex !important;\n  }\n  .header-container {\n    .header-right-container {\n      position: fixed;\n      top: 0%;\n      z-index: 100;\n      background: white;\n      right: -15px;\n      width: 300px;\n      height: 100%;\n      transform: translateX(100%);\n      transition: 0.3s;\n      z-index: 101;\n\n      &.show {\n        .mobile-view-close-btn-wrapper {\n          padding: 0 15px;\n          border-bottom: 1px solid rgba(220, 220, 220, 0.5);\n          display: flex !important;\n          justify-content: right;\n        }\n      }\n\n      .hd-content-wrapper {\n        display: flex;\n        align-items: center;\n\n        span {\n          margin-left: 20px;\n        }\n      }\n\n      &.show {\n        transform: translateX(0);\n      }\n    }\n\n    .pay-btn {\n      display: flex;\n      justify-content: center;\n      padding: 8px 12px !important;\n      font-size: 18px;\n      width: 50%;\n    }\n\n    .login-btn {\n      font-size: 18px;\n      padding: 8px 12px !important;\n      width: 50%;\n    }\n\n    .navbar-toggler {\n      display: block !important;\n      height: 45px;\n      margin: 5px 0;\n      border: none !important;\n    }\n  }\n}\n\n@media only screen and (max-width: 576px) {\n  .header-container {\n    .header-left-container {\n      .select-city-btn {\n        .select-city-dropdown-btn {\n          margin-left: 20px;\n          max-width: 200px;\n        }\n        .address-dropdown {\n          width: 90vw;\n          left: 0;\n          right: 0;\n          margin: 0 auto;\n          position: fixed;\n          top: 55px;\n          transform: scale(1);\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 420px) {\n  .header-container {\n    .header-left-container {\n      .select-city-btn {\n        .select-city-dropdown-btn {\n          max-width: 100px;\n        }\n\n        .address-dropdown {\n          width: 100vw;\n          height: 100%;\n          left: 0;\n          right: 0;\n          // margin: over0 auto;\n          overflow-y: auto;\n          position: fixed;\n          top: 0;\n          transform: scale(1);\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
